// Outcome radios on the DSR task panel (DevDsrCollaboratorTasks). Wire mapping (feedback `newState`):
// Completed / Attached → Resolved, NoData → Responded (copy only), NotCompleted / NotAttached → Canceled (note required).
export enum DsrTaskOutcome {
    Completed = 'Completed',       // delete: "I completed the task"
    NotCompleted = 'NotCompleted', // delete: "I couldn't complete the task"
    Attached = 'Attached',         // copy: "I attached the data"
    NoData = 'NoData',             // copy: "No data was found" — completes with zero files (already uploaded files stay)
    NotAttached = 'NotAttached',   // copy: "I couldn't attach the data"
}
